import React from "react";

import { MenuRounded, ShoppingBasketRounded } from "@mui/icons-material";
import { Box, Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Constants } from "../../../../config/constants";
import useAuth from "../../../../config/context/authContext";
import useFirebase from "../../../../config/context/firebaseContext";
import useMainState from "../../../../config/context/mainStateContext";
import useModal from "../../../../config/context/modalContext";
import { CafeteriaService } from "../../../../config/services/CafeteriaService";
import { UtilComponents } from "../../../../config/util/utilComponents";

import ChipMain from "../../../../components/InputMain/ChipMain";
import MainConfigBanner from "../../../../components/MainConfigBanner";
import MainLinkButton from "../../../../components/MainLinkButton";
import MainText from "../../../../components/MainText";
import PageHeader from "../../../../components/PageHeader";

import CafeteriaPage from "./components/CafeteriaPage";
import RuPage from "./components/RuPage";

export default function ListingSubTab() {
  const navigate = useNavigate();

  const { getConfig, analyticLog } = useFirebase();

  const { setShowSideMenuDrawer } = useMainState();
  const { currentUserState } = useAuth();
  const { pushAlert } = useModal();

  const CafeteriaList = CafeteriaService.List();

  const [loading, setLoading] = React.useState(false);

  const [tabShow, setTabShow] = React.useState("ru");

  React.useEffect(() => {
    analyticLog("click_food_tab");
  }, []);

  React.useEffect(() => {
    if (tabShow !== "ru") {
      CafeteriaList.runRequest(tabShow).catch((err) =>
        pushAlert({ type: "error", message: "Erro ao obter vendedores. " + err.message })
      );
    }
  }, [tabShow]);

  return (
    <Box style={{ width: "100%" }}>
      <PageHeader
        title="Cardápio"
        leftIcon={<MenuRounded />}
        onLeftAction={() => setShowSideMenuDrawer(true)}
        rightIcon={
          getConfig("enabled_cafeteria") || UtilComponents.isStaff(currentUserState) ? (
            <ShoppingBasketRounded />
          ) : undefined
        }
        onRightAction={() => navigate("/home/menu/orders")}
      />

      <MainConfigBanner screen="menu" />

      {getConfig("enabled_cafeteria") || UtilComponents.isStaff(currentUserState) ? (
        <Box mb={2} gap={1} display={"flex"} flexWrap={"wrap"}>
          <ChipMain
            options={[{ name: "RU", value: "ru" }, ...Constants.cafeteriaSpots]}
            onChange={(value) => setTabShow(value as string)}
            value={tabShow}
          />
        </Box>
      ) : null}

      {tabShow === "ru" && <RuPage />}

      {tabShow !== "ru" &&
        (CafeteriaList.isLoading ? (
          [1, 2].map((index) => (
            <Skeleton
              key={index}
              animation="wave"
              variant="rounded"
              width={"100%"}
              height={130}
              sx={{ borderRadius: "15px", mb: 2 }}
            />
          ))
        ) : CafeteriaList.items.length ? (
          <CafeteriaPage cafeterias={CafeteriaList.items} />
        ) : (
          <MainText size="caption" color="regular">
            Nenhum vendedor encontrado...
          </MainText>
        ))}

      {tabShow !== "ru" && (
        <MainLinkButton text="Quero me Tornar um Vendedor" onClick={() => navigate("/cafeteria")} />
      )}
    </Box>
  );
}
